import { useEffect, useRef } from "react";
import { Chat } from "src/lib";
import { useDrawerStore } from "src/store/drawerStore";
import { useMessageStore } from "src/store/messageStore";
import { useRankingStore } from "src/store/rankingStore";

const LateralChat = () => {
    const toggle = useDrawerStore((s: any) => s.toggle);
    const isFullscreen = useDrawerStore((s: any) => s.isFullscreen);
    const setFullscreen = useDrawerStore((s: any) => s.setFullscreen);
    const toggleFullscreen = useDrawerStore((s: any) => s.toggleFullscreen);
    const clearRankings = useRankingStore((s: any) => s.clearRankings);
    const msgContext = useMessageStore((s: any) => s.actualContext)
    const messages = useMessageStore((s: any) => s.messages)
    const messagesEndRef = useRef<HTMLDivElement | null>(null);
    const setActualContext = useMessageStore((s: any) => s.setActualContext)

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const handleCloseChat = () => {
        clearRankings();
        setActualContext(undefined)
        setFullscreen(false);
        toggle();
    }
    
    function normalizeMarkdownTable(markdown: string): string {
        const lines = markdown?.split('\n');

        const headerIndex = lines?.findIndex((line) => line.includes('|'));
        if (headerIndex === -1 || headerIndex + 1 >= lines?.length) return markdown;

        const headerLine = lines[headerIndex].trim();
        const separatorLine = lines[headerIndex + 1].trim();

        const countPipes = (line: any) => [...line].filter(char => char === '|').length;

        const headerPipeCount = countPipes(headerLine);
        const separatorPipeCount = countPipes(separatorLine);

        if (headerPipeCount !== separatorPipeCount) {
            lines[headerIndex + 1] = '|---|';
        }

        return lines.join('\n');
    }

    return (
        <Chat.Root>
            <Chat.Header
                onClose={handleCloseChat}
                onToggleFullscreen={toggleFullscreen}
                isFullscreen={isFullscreen}
            />
            <Chat.Content>
                {
                    messages.map((message: {
                        text: string
                        timestamp: Date;
                        context?: string;
                        answer?: boolean;
                        id: string;
                        jsonMessage?: any;
                        questionText?: string;
                    }) => (
                        <Chat.Message
                            key={message.id}
                            context={message.context}
                            answer={message.answer}
                            timestamp={message?.timestamp?.toLocaleDateString('pt-BR')}
                            jsonMessage={message.jsonMessage}
                            questionText={message.questionText}
                        >
                            {normalizeMarkdownTable(message.text)}
                        </Chat.Message>
                    ))
                }
                <div ref={messagesEndRef} />
            </Chat.Content>
            <Chat.BottomArea context={msgContext} />
        </Chat.Root>
    )
}

export { LateralChat };
